var fsObj: any = null;

export default class FadeShow
{
	parentId: string = '';
	slides: string[] = [];
	options = {};
	timerId: number = 0;
	slideDuration: number = 5000;

	constructor(parentId: string, slides: string[] = [], options = {}) {
		this.parentId = parentId;
		this.slides = slides;
		this.options = options;

		this.init();
	}

	startTrans() {
		if (window.innerWidth < 1024) { return; }
		
		let slideWrap: HTMLElement|null = document.querySelector('.fs_wrap');
		if (!slideWrap) { return; }
		let topSlide: HTMLElement|null = slideWrap.querySelector('.fs_top');
		let nextSlide: HTMLElement|null = slideWrap.querySelector('.fs_next');
		if (!topSlide || !nextSlide) { return; }
		topSlide.classList.add('fs_anim');
		topSlide.addEventListener('animationend', ()=>{
			if (slideWrap.querySelectorAll('.fs_anim').length == 0) { return; }

			topSlide.classList.remove('fs_anim');
			topSlide.classList.remove('fs_top');
			nextSlide.classList.remove('fs_next');
			nextSlide.classList.add('fs_top');
			let sib: Element|null = nextSlide.nextElementSibling;
			if (!sib) {
				sib = slideWrap.firstElementChild;
			}
			if (sib) {
				sib.classList.add('fs_next');
				//sib.setAttribute('style', "opacity: 1;");
			}
			console.log('before animation end settimeout');
			fsObj.timerId = window.setTimeout(fsObj.startTrans, fsObj.slideDuration);
		});

	}

	init() {
		fsObj = this;
		const parent = document.getElementById(this.parentId);
		if (!parent) { throw new Error('parent not found'); }
		let wrap: HTMLElement = document.createElement('div');
		wrap.classList.add('fs_wrap');
		parent.appendChild(wrap);

		for (var i = 0; i < this.slides.length; i++) {
			let slide = this.createSlide(this.slides[i]??'');
			if (i == 0) { 
				slide.classList.add('fs_top');
			} else if (i == 1) {
				slide.classList.add('fs_next');
			}
			wrap.appendChild(slide);
			wrap.style.height = slide.clientHeight+"px";
		}

		this.timerId = window.setTimeout(this.startTrans, this.slideDuration);
	}

	createSlide(slideImgPath: string) : HTMLElement {
		let slide: HTMLElement = document.createElement('div');
		slide.classList.add('fs_slide');
		let img = document.createElement('img');
		img.src = slideImgPath;
		img.setAttribute('width', '100%');
		img.addEventListener('load',this.adjustWrapHeight);
		slide.appendChild(img);

		return slide;
	}

	adjustWrapHeight = ()=> {
		const parent = document.getElementById(this.parentId);
		if (parent) {
			let wrap: HTMLElement|null = parent.querySelector('.fs_wrap');
			if (wrap) {
				let top = wrap?.querySelector('.fs_top');
				wrap.style.height = top?.clientHeight+'px';	
			}
		}
	}
}


window.addEventListener('resize', () => {
	if (fsObj) {
		fsObj.adjustWrapHeight();
	}
});